import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import getGroupUrl from 'helpers/getGroupUrl'

import { NotFound } from 'js/core/NotFound'
import {
    GET_GENERIC_ARTICLE,
    GET_VIEWER_RIGHTS,
} from 'js/genericArticle/Detail.queries'
import { FEED_VIEW_WRAPPER } from 'js/page/Widget/components/Feed/FeedView.queries'
import { FEED_ACTIVITIES } from 'js/page/Widget/components/Feed/FeedViewList.queries'

import ItemLayout from './components/ItemLayout'

const Detail = () => {
    const params = useParams()
    const { guid, groupGuid } = params

    const { loading, data } = useQuery<any>(GET_GENERIC_ARTICLE, {
        variables: {
            guid,
            groupGuid,
        },
    })

    const { data: viewerData, loading: viewerLoading } = useQuery<any>(
        GET_VIEWER_RIGHTS,
        {
            variables: {
                subtype: data?.entity?.contentType?.key || '',
                groupGuid: data?.entity?.group?.guid || '',
            },
            skip: !data?.entity,
        },
    )

    if (loading || viewerLoading) {
        return null
    }
    if (!data || !data.entity || !viewerData) {
        return <NotFound />
    }

    const { entity } = data
    const { contentType } = entity
    const { slug, formFields, hasFeaturedImage } = contentType

    const { detailViewTemplateIds } = contentType

    const onEdit = `${getGroupUrl(params)}/${slug}/edit/${guid}`
    const onAfterDelete = `${getGroupUrl(params)}/`

    const refetchQueries = [
        FEED_ACTIVITIES,
        FEED_VIEW_WRAPPER,
        GET_GENERIC_ARTICLE,
    ]

    return (
        <ItemLayout
            viewer={viewerData?.viewer}
            entity={{
                ...entity,
                // If showFeatured is disabled in admin, we should remove the possible featured image from the entity
                featured: hasFeaturedImage ? entity.featured : {},
            }}
            onEdit={onEdit}
            onAfterDelete={onAfterDelete}
            options={{
                author: detailViewTemplateIds.includes('author'),
                publishDate: detailViewTemplateIds.includes('publishDate'),
                views: detailViewTemplateIds.includes('views'),
                save: detailViewTemplateIds.includes('save'),
                likes: detailViewTemplateIds.includes('likes'),
                follow: detailViewTemplateIds.includes('follow'),
                share: detailViewTemplateIds.includes('share'),
                comments: detailViewTemplateIds.includes('comments'),
            }}
            formFields={formFields}
            refetchQueries={refetchQueries}
            {...({} as any)}
        />
    )
}

export default Detail
